var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRefresh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.99,
    height: 15.621,
    viewBox: "0 0 18.99 15.621",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.19 -0.189)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.431,9.284a.557.557,0,0,0-.8-.147A5.086,5.086,0,0,1,4.421,5.221V5.137H5.684a.39.39,0,0,0,.337-.589L3.389.189a.394.394,0,0,0-.674,0L.063,4.547A.384.384,0,0,0,.4,5.137H1.7A7.794,7.794,0,0,0,4,10.653a7.792,7.792,0,0,0,10.168.758.53.53,0,0,0,.126-.716Z",
    transform: "translate(0.19 2.863)",
    fill: "#069"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.932,7.811H12.648A7.835,7.835,0,0,0,4.837,0,7.662,7.662,0,0,0,.227,1.516a.536.536,0,0,0-.147.716L.942,3.642a.533.533,0,0,0,.779.147A5.018,5.018,0,0,1,4.732,2.737a5.092,5.092,0,0,1,5.2,5.074H8.627A.39.39,0,0,0,8.29,8.4l2.653,4.358a.394.394,0,0,0,.674,0l2.653-4.337A.4.4,0,0,0,13.932,7.811Z",
    transform: "translate(4.847 0.189)",
    fill: "#069"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRefresh);
export default __webpack_public_path__ + "static/media/icon-refresh.d17733e20bdb8c49fe6d50d9eb1ed42e.svg";
export { ForwardRef as ReactComponent };